<template>
  <div>
    <b-alert :show="request_err" variant="warning">{{ request_err }}</b-alert>
    <CForm>
      <CRow>
        <CCol sm="12">
          <!-- <CSelect
                  label="Ticket Type"
                  placeholder=""
                  :value.sync="form.type"
                  :horizontal="true"
                  :options="types"
                  :isValid="(valid.type ? (valid.type === true) : null)"
                  :invalidFeedback="valid.type"
          /> -->
          <b-form-group label="Ticket Type" label-cols-sm="3">
            <b-form-radio-group
              v-model="form.type"
              :options="types"
              buttons
              :isValid="(valid.type ? (valid.type === true) : null)"
              :invalidFeedback="valid.type"
            ></b-form-radio-group>
          </b-form-group>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <CInput
                  label="Subject"
                  placeholder=""
                  v-model="form.subject"
                  :horizontal="true"
                  :isValid="(valid.subject ? (valid.subject === true) : null)"
                  :invalidFeedback="valid.subject"
          />
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <CTextarea
                  label="Description"
                  placeholder=""
                  v-model="form.description"
                  :horizontal="true"
                  :isValid="(valid.description ? (valid.description === true) : null)"
                  :invalidFeedback="valid.description"
          />
        </CCol>
        <CCol sm="12" v-if="form.type === 'bug'">
          <CTextarea
                  label="Steps to re-produce:"
                  placeholder=""
                  v-model="form.steps_to_reproduce"
                  :horizontal="true"
                  :isValid="(valid.steps_to_reproduce ? (valid.steps_to_reproduce === true) : null)"
                  :invalidFeedback="valid.steps_to_reproduce"
          />
        </CCol>
        <CCol sm="12" v-if="form.type === 'bug'">
          <CTextarea
                  label="Expected outcome"
                  placeholder=""
                  v-model="form.expected_outcome"
                  :horizontal="true"
                  :isValid="(valid.expected_outcome ? (valid.expected_outcome === true) : null)"
                  :invalidFeedback="valid.expected_outcome"
          />
        </CCol>
      </CRow>
    </CForm>
<!--    <CRow>-->
<!--      <CCol sm="7"></CCol>-->
<!--      <CCol sm="5">-->
<!--        <CButtonGroup class="w-100">-->
<!--          <CButton @click="$emit('cancel')" color="default" class="btn-square">Cancel</CButton>-->
<!--          <CButton class="btn-sf btn-square" @click="save">Save</CButton>-->
<!--        </CButtonGroup>-->
<!--      </CCol>-->
<!--    </CRow>-->
  </div>
</template>

<script>
  import Ticket from "../../models/Ticket";

  export default {
    name: 'TicketForm',
    data() {
      return {
        request_err: null,
        types: [
          {value: 'general', text: 'General'},
          {value: 'marketing', text: 'Marketing'},
          {value: 'technical', text: 'Technical'},
          {value: 'bug', text: 'Bug'}
        ],
        form: {
          type: 'general',
          subject: null,
          description: null,
          steps_to_reproduce: null,
          expected_outcome: null,
          url: window.location.origin + '/#' + this.$router.currentRoute.fullPath
        },
        valid: {
          type: null,
          subject: null,
          description: null,
          steps_to_reproduce: null,
          expected_outcome: null
        }
      };
    },
    methods: {
      validate() {
        let valid = true;
        if(!this.form.type || this.form.type === '') {
          this.valid.type = 'No ticket type was selected.';
          valid = false;
        } else {
          this.valid.type = true;
        }
        if(!this.form.subject || this.form.subject === '') {
          this.valid.subject = 'Please provide a subject.';
          valid = false;
        } else {
          this.valid.subject = true;
        }
        if(!this.form.description || this.form.description === '') {
          this.valid.description = 'Please provide a description.';
          valid = false;
        } else {
          this.valid.description = true;
        }
        if(this.form.type === 'bug' && !this.form.steps_to_reproduce || this.form.steps_to_reproduce === '') {
          this.valid.steps_to_reproduce = 'Please provide some basic steps on how to re-produce the issue.';
          valid = false;
        } else {
          this.valid.steps_to_reproduce = true;
        }
        if(this.form.type === 'bug' && !this.form.expected_outcome || this.form.expected_outcome === '') {
          this.valid.expected_outcome = 'Please the expected outcome.';
          valid = false;
        } else {
          this.valid.expected_outcome = true;
        }
        return valid;
      },
      save() {
        this.$emit('onSaving');
        if(!this.validate()) {
          this.$emit('onFail');
          return false;
        }
        let payload = JSON.parse(JSON.stringify(this.form));
        this.createTicket(payload).then((ticket) => {
          if(ticket) {
            this.$emit('onSaved', ticket);
          } else {
            this.$emit('onFail');
          }
        });
      },
      createTicket: function (payload) {
        payload.user_agent = navigator.userAgent;
        return Ticket.api().create(payload).then((response) => {
          return response.entities.tickets[0];
        }, () => {
          this.request_err = 'The ticket could not be submitted at this time. Please try again.';
          return false;
        });
      },
    },
    created() {
      this.form = {
        type: 'general',
        subject: null,
        description: null,
        url: window.location.origin + '/#' + this.$router.currentRoute.fullPath
      }
    }
  }
</script>
